export default {
  gutterBottom: {
    marginBottom: 8
  },
  root: {
    fontFamily: "'Fira Sans', sans-serif !important",
    fontWeight: 'bolder !important'
  },
  colorSecondary: {
    color: '#ffffff !important'
  },
  colorTextSecondary: {
    color: '#ffffff !important'
  },
  body2: {
    fontWeight: 'normal !important',
    fontSize: '0.8rem',
    textAlign: 'justify'
  },
  body1: {
    fontSize: '0.9rem'
  }
}
